import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoGracias from "../graciasrepuesto/InfoGracias";
const Footer = lazy(() => import('../footer/Footer'));
function GraciasRepuesto(props) {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="El Hyundai Accent ofrece un diseño de líneas puras con una óptica excelente, tecnología avanzada y prestaciones de seguridad y rendimiento superiores"
        />
        <meta
          name="keywords"
          content="Automóvil, Sedán, Hyundai, Hyundai Accent, Accent, mejor sedán, taxi"
        />
        <title>Gracias por cotizar</title>
      </Helmet>
      <Menu />
      <InfoGracias datos={props} />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default GraciasRepuesto;